import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { put } from '../../utils/api';
import { Form, FormLine, FormItem } from '../common/Form';
//
// Компонент для редактирования блока текста об экспоненте.
// Используется для редактирования brief, about, descr.
//
const ExhibitorEditText = ({ fname, subtitle, limit }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
    const exhibitor = useSelector(state => state.exhibitor);
	const [ fieldRu, setFieldRu ] = useState(exhibitor[fname].ru);
	const [ fieldEn, setFieldEn ] = useState(exhibitor[fname].en);
    const [ disabled, setDisabled ] = useState(true);
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');

    // Проверка того, что все обязательные данные есть
    useEffect(() => {
		setDisabled(!(fieldRu && fieldEn));
    }, [ fieldRu, fieldEn ]);

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');
        setSuccess('');

        const data = {};
        data[fname+'_ru'] = fieldRu;
        data[fname+'_en'] = fieldEn;

        const result = await put('/exhibitors/' + exhibitor._id, data);

        if(result.error) {
            setSaveError(result.error);
        } else {
            setSuccess('exhibitoredit.success');
			navigate('/cabinet/exhibitorview/' + exhibitor._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{t('exhibitoredit.title')}</h1>
			{isSaving ? <span>{t('common.loading')}</span> :
			<Form
                success={success}
                error={saveError}
                info={subtitle}
                wide={true}
            >
				<FormLine>
                    <FormItem>
                        <label htmlFor='fieldRu'>{t('exhibitoredit.'+fname+'_ru')}</label>
                        <textarea
                            id='fieldRu'
                            rows='5'
                            value={fieldRu}
                            onChange={e => setFieldRu(e.target.value.substring(0, limit))}
                            placeholder={t('exhibitoredit.'+fname+'_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <label htmlFor='fieldEn'>{t('exhibitoredit.'+fname+'_en')}</label>
                        <textarea
                            id='fieldEn'
                            rows='5'
                            value={fieldEn}
                            onChange={e => setFieldEn(e.target.value.substring(0, limit))}
                            placeholder={t('exhibitoredit.'+fname+'_en')}
                        />
                    </FormItem>
                </FormLine>

				<input
					id='submit'
					type='submit'
					value={t('common.save_changes')}
					disabled={disabled}
					onClick={onSubmit}
				/>

			</Form>}
		</div>
	);
};

ExhibitorEditText.propTypes = {
    fname: PropTypes.string.isRequired, // название поля
    subtitle: PropTypes.string.isRequired, // пояснение перед формой
    limit: PropTypes.number.isRequired, // ограничение на длину знаков
};

export default ExhibitorEditText;
